import Project from './Project';
import { ProjectsSystem, IStoredProjectFolder, ProjectFolderType } from './ProjectsSystem';
import ProjectFolder from './ProjectFolder';
import { ProjectRelatedDocument } from '../documents/ProjectRelatedDocument';
import { ProjectSystemFolder } from './ProjectSystemFolder';
import { t } from 'i18next';

export class ProjectActivityFolder extends ProjectSystemFolder {
  static fromIProjectFolder(system: ProjectsSystem, project: Project, folder: IStoredProjectFolder) {
    return new this(system, project, folder.pca_id, t('Actividades'), undefined, ProjectFolderType.activities);
  }

  moveInto(documents: ProjectRelatedDocument[]): Promise<void> {
    throw new Error('Can not move documents to activities folder.');
  }

  addChildNamed(childName: string): Promise<ProjectFolder> {
    throw new Error('Can not add project folder to activities');
  }

  isTrash(): boolean {
    return false;
  }
}
